module.exports = __webpack_public_path__ + "static/media/icon-phone.3d4ff625.svg";